<template>
  <div class="cake-con">
    <div class="header">
      <div class="title">请选择蛋糕</div>
      <div class="tips">
        <p>已选员工：{{staffNames}}</p>
      </div>
    </div>
    <div v-if="loading" style="text-align: center; padding-top: 100px">
      <loading size="24px">加载中...</loading>
    </div>
    <div class="list" v-else-if="!loading && this.cakeList.length>0">
      <div
        v-for="cake in cakeList"
        :key="cake.id"
        :class="selected && selected.id === cake.id ? 'cake-selected':''"
        @click="cakeChoose(cake)"
        class="cake"
      >
        <div class="image">
          <VanImage :src="cake.pictureUrl" width="100%" height="100%" fit="cover" />
        </div>
        <div class="desc">
          <tag color="#ef4c4f" type="primary" style="margin-right: 4px">{{cake.cakeSize}}</tag>
          <span>{{cake.commodityName}}</span>
        </div>
      </div>
    </div>
    <empty v-else description="暂无数据" />
  </div>
</template>

<script>
import { Tag, Image as VanImage, Loading, Empty } from 'vant';
import { queryCakeInfos } from '@/api/birthday';

export default {

  components: {
    Tag,
    VanImage,
    Loading,
    Empty,
  },

  props: ['orderInfo'],

  data() {
    return {
      loading: false,
      cakeList: [],
      selected: null,
    };
  },

  mounted() { },

  computed: {

    // 过生日的员工姓名
    staffNames() {
      if (!this.orderInfo.staff) {
        return '';
      }
      return this.orderInfo.staff.map(staff => staff.personName).join(', ');
    },
  },

  methods: {

    /**
     * 初始化蛋糕列表
     *
     * 员工选一人，此页面只显示单人蛋糕；
     * 选两人，只显示双人蛋糕；
     * 选三人，只选择三人蛋糕列表；
     */
    init() {
      this.loading = true;
      // 清空已选择的蛋糕
      this.selected = null;
      const params = {
        personSize: this.orderInfo.staff.length,
      };
      queryCakeInfos(params).then(res => {
        this.cakeList = res;
      }).catch(({ message = '系统异常' }) => {
        this.$toast(message);
      }).finally(() => {
        this.loading = false;
      });
    },

    cakeChoose(e) {
      this.selected = e;
    },

    /**
     * 下一步检查
     */
    nextCheck() {
      return this.selected || null;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  .cake {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    overflow: hidden;
    .image {
      width: 100%;
      height: 200px;
    }
    .desc {
      padding: 20px;
    }
  }
  .cake-selected {
    border: 1px solid #ef4c4f;
    box-shadow: 0 0 10px 5px #fcbabb;
  }
}
</style>